module.exports = __webpack_public_path__ + "img/hangtian.c7063995.jpg";